import Dropzone from 'dropzone';
import { hex_md5 } from '../../../common/components/md5';
import axios, { AxiosRequestConfig } from 'axios';

export class DoItForYou {
    store;
    dropzone;
    doItForYou: HTMLElement = null
    formElement: HTMLFormElement = null;

    async init(store) {
        this.store = store;
        this._initDropZone();
        this._storeSubscribe();

        this.formElement = document.querySelector('.do-it-for-you__message-box');
        this.formElement.addEventListener('submit', (event) => this._onSubmit(event));

        this.doItForYou = document.querySelector('.do-it-for-you');

        const newRequestButton = document.querySelector('.do-it-for-you__button--send-another-form');
        newRequestButton.addEventListener('click', () => this._newRequest());
    }

    _newRequest() {
        this.doItForYou.classList.remove('do-it-for-you--request-completed')
    }

    _storeSubscribe() {
        let unwatch = this.store.watch((state, getters) => state.recaptcha.recaptchaLoaded, (newVal, oldVal) => {
            if (newVal === true) {
                this._initRecaptcha();
                unwatch();
            }
        },{
            immediate: true,
        });
    }

    _initDropZone() {
        Dropzone.autoDiscover = false;
        const previewTemplate = `
            <li class="do-it-for-you__file-item" class="files">
                <div class="do-it-for-you__file-preview">
                    <span class="preview"><img data-dz-thumbnail class="do-it-for-you__file-preview-image" /></span>
                </div>
                <div class="do-it-for-you__file-name-container">
                    <p class="do-it-for-you__file-name name" data-dz-name></p>
                    <strong class="error text-danger" data-dz-errormessage></strong>

                </div>
                <div class="do-it-for-you__file-status">
                    <div class="do-it-for-you__file-status-icon-container">
                        <svg class="do-it-for-you__file-status-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20 6L9 17L4 12" stroke="#00A71A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <span class="do-it-for-you__file-status-title do-it-for-you__file-status-title--uploading">Waiting</span>
                    <div class="do-it-for-you__progressbar" role="progressbar" data-dz-uploadprogress>
                        <span class="do-it-for-you__progressbar-value"></span>
                    </div>
                </div>
                <div class="do-it-for-you__file-delete">
                  <button data-dz-remove class="do-it-for-you__button do-it-for-you__button--delete">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M18 2L2 18" stroke="#82979B" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M2 2L18 18" stroke="#82979B" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
                </div>
            </li>
            `;

        this.dropzone = new Dropzone('.do-it-for-you__upload-zone', {
            url: 'handlers/UploadHandler.ashx?action=uploadAppRequestFile',
            previewsContainer: '.do-it-for-you__file-list',
            acceptedFiles: 'image/*, application/pdf, .xls, .xlsx',
            previewTemplate,
        });

        this.dropzone.on('sending', (file, xhr, formData) => {
            let date = new Date();
            let datestring = date.getTime();
            let md5 = hex_md5(datestring + file.name);
            let ext = file.name.split('.').pop();
            let currentUploadFilename = md5 + '.' + ext;

            formData.append('timehash', currentUploadFilename);
            file.previewElement.classList.add('do-it-for-you__file-item--uploading');
            file.previewElement.querySelector('.do-it-for-you__file-status-title').textContent = `Uploading`;
        });

        this.dropzone.on('uploadprogress', (progress, progressPercentage) => {
            const progressRoundPercentage = Math.round(progressPercentage);
            progress.previewElement.querySelector('.do-it-for-you__progressbar-value').textContent = `${progressRoundPercentage}%...`;
        });


        this.dropzone.on('success', file => {
            try {
                let result = JSON.parse(file.xhr.response)
                const inputElement = document.createElement('input');
                inputElement.setAttribute('type', 'hidden');
                inputElement.setAttribute('name', 'file');
                inputElement.value = result.url;

                file.previewElement.classList.remove('do-it-for-you__file-item--uploading')
                file.previewElement.classList.add('do-it-for-you__file-item--uploaded')

                file.previewElement.querySelector('.do-it-for-you__file-status-title').textContent = `Uploaded`;
                file.previewElement.querySelector('.do-it-for-you__progressbar-value').textContent = ``;
                file.previewElement.append(inputElement);
            } catch (e) {
                //
            }

        });
    }


    _initRecaptcha() {
        const reCaptchaSiteKey = '6LcP-McqAAAAABG616o9tg0O7quZcfbEqr0iikaD';

        let recaptchaBox: HTMLElement = document.querySelector('.do-it-for-you__recaptcha');

        let reCaptchaId = grecaptcha.enterprise.render(recaptchaBox, {
            'sitekey': reCaptchaSiteKey
        });

        recaptchaBox.dataset.recaptcha = reCaptchaId.toString();
    }

    async _onSubmit(event) {
        event.preventDefault();
        let isgReCaptchaUsed = true;

        let fieldsValid = true;
        let trackFBLead = false;
        const doitForYou: HTMLFormElement = document.querySelector('.do-it-for-you');

        if (fieldsValid) {
            const doItForYouData = new FormData(this.formElement);
            doItForYouData.append('type', `universalFormHandler`);
            doItForYouData.append('recap-new-handler', encodeURIComponent(isgReCaptchaUsed));
            doItForYouData.append('previousPage', document.referrer);

            const fileInputs = this.formElement.querySelectorAll('input[name="file"]');
            const fileUrls = [].reduce.call(fileInputs, (accumulator, currentValue) => {
                accumulator += `file: ${currentValue.value};`;
                return accumulator;
            }, '');

            if (fileUrls != '') {
                doItForYouData.append('description', ` ${fileUrls}`);
            }

            const doItForYouOpt: AxiosRequestConfig = {
                method: 'post',
                url: 'handlers/registration.ashx',
                data: doItForYouData,
                headers: { 'Content-Type': 'multipart/form-data' },
            };

            try {
                doitForYou.classList.add('do-it-for-you--loading');

                let response = await axios(doItForYouOpt);

                if (response.data === 'Ok') {
                    this.formElement.reset();
                    let reCaptchaBox: HTMLElement = document.querySelector('.do-it-for-you__recaptcha');
                    let registrationRecaptchaId: number = parseInt(reCaptchaBox.dataset.recaptcha);
                    grecaptcha.enterprise.reset(registrationRecaptchaId);
                    this.dropzone.files.forEach((file) => this.dropzone.removeFile(file));
                }

                doitForYou.classList.remove('do-it-for-you--loading');
                doitForYou.classList.add('do-it-for-you--request-completed');
            } catch (e) {

            }
               
        }

    }
} 